<template>
    <article class="dd-m-card dd-m-card--featured-product">
        <a :href="item.link"
           :target="item.target === 2 ? '_blank': ''"
           :title="item.title">
           <div class="dd-m-card--featured-product__content">
                <picture class="dd-m-card--featured-product__thumb">
                    <source :srcset="item.image.desktop" media="(min-width: 1280px)">
                    <source :srcset="item.image.tablet" media="(min-width: 768px)">
                    <img :srcset="item.image.mobile" :alt="item.title">
                </picture>

                <h3 class="dd-m-card--featured-product__title">
                    {{item.title}}
                </h3>
            </div>

            <div class="dd-m-card--featured-product__description">
                {{item.description}}
            </div>
        </a>
    </article>
</template>
<script>
    export default {
        name: 'card-featured-product',
        props: ['item'],
        mounted() {
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card-featured-product.vue